<template>
  <!-- 审批流查询，列表界面 -->
  <div class="wfClass">
    <van-nav-bar :title="title" left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <div class="search">
      <van-search v-model="value" placeholder="请输入搜索关键词" @input="onSearch" />
      <van-checkbox 
        style="font-size: 16px;margin-left: 10px;" 
        v-show="showcheck" 
        v-model="checked" 
        icon-size="14px"
        @click="checkAll(checked)"
      >全选</van-checkbox>
      <div 
        class="gettype" 
        @click="showPicker = true" 
        v-if="type == '2'"
      >
        <span>{{ sstype }}<van-icon name="arrow-down" /></span>
      </div>
      <div 
        style="width: 36px;height: 36px;margin-left: 10px;min-width: 36px;min-height: 36px; display: flex;align-items: center;" 
        @click="showcheck = !showcheck"
        v-if="(type == '1' || type == '2' || type == '4' || type == '5') && app_forchecklist_can_batch"
      >
        <svg-icon style="width: 36px;height: 36px;min-width: 36px;min-height: 36px;" icon-class="wfListType"></svg-icon>
      </div>
      <div style="width: 36px;height: 36px;    display: flex;
    align-items: center;min-width: 36px;min-height: 36px;margin-left: 10px;margin-right: 5px;" @click="onShowCalendar">
        <svg-icon style="width: 36px;height: 36px;min-width: 36px;min-height: 36px;" icon-class="wfListYue"></svg-icon>
      </div>
    </div>

    <div :style="showIt?'opacity:1':'opacity:0'" class="applyCollapse" id="applyCollapse" :class="{ showcheck: showcheck, homeAppClassIs1: homeAppClass }"
      v-if="app_forchecklist_showasform && type == 1 && formautoid != 0">
      <div class="appForchecklistShowasformContainer" v-for="(value, key) in afworkflowlist" :key="key"
        @click="jump(value)">
        <div class="appForchecklistShowasformContainerTop">
          <div class="appForchecklistShowasformContainerTopLeft">
            <div class="beforcell">
              <van-checkbox v-if="showcheck && !(value.ischeck || value.return)" v-model="value.checked"
                shape="square" />
              <div class="ico"></div>
            </div>
            {{ value.applistmemo }}
          </div>
          <div class="appForchecklistShowasformContainerTopRight">
            <span :cx_flag="value.cx_flag" :class="{ st: true, ischeck: value.ischeck, isdtj: type == 5 }"
              :style="value.cx_flag == 0 ? 'color: #eb905b;background: #f5efc1;' : value.cx_flag == 1 ? 'color: #666;background: #ccc;' : value.cx_flag == 2 ? 'color: #6042d9;background: #c9c1f5;' : value.cx_flag == 3 ? 'color: #00b65b;background: #c1f5ea;' : 'color: #eb905b;background: #f5efc1;'">
              {{
                value.cx_flag == 0 ? '审批中' : value.cx_flag == 1 ? '已撤销' : value.cx_flag == 2 ? '已否决' : value.cx_flag ==
                  3 ? '已通过' : value.cx_flag == 4 ? '待提交' : '请审批'
              }}
            </span>
          </div>
        </div>
        <div class="appForchecklistShowasformContainerBody" v-if="value.checkdatalist && value.checkdatalist.newArr">
          <div class="appForchecklistShowasformContainerBodyContent" v-for="(item, index) in value.checkdatalist.newArr"
            :key="index">
            <div class="appForchecklistShowasformContainerBodyLeft" style="padding-left: 8px;">
              {{ item.key }}：
            </div>
            <div class="appForchecklistShowasformContainerBodyRight">
              {{ item.value }}
            </div>
          </div>
        </div>
        <div class="appForchecklistShowasformContainerFooter" v-if="!showcheck">
          <van-button @click.stop="shenPiEvent(1, value)" v-if="value.use_flow_push" type="primary"
            style="width: 65px;height: 38px;border-radius: 5px;">{{ value.cb_btn_caption }}</van-button>
          <van-button @click.stop="shenPiEvent(2, value)" v-if="value.usezb" type="primary"
            style="width: 65px;height: 38px;border-radius: 5px;">{{ value.zb_btn_caption }}</van-button>
          <van-button @click.stop="shenPiEvent(3, value)" v-if="value.can_backto_fix_node" type="warning"
            style="width: 65px;height: 38px;border-radius: 5px;">回退</van-button>
          <van-button @click.stop="shenPiEvent(4, value)" type="info"
            style="width: 65px;height: 38px;border-radius: 5px;">同意</van-button>
          <van-button @click.stop="shenPiEvent(5, value)" v-if="!value.hide_cancel_btn" type="danger"
            style="width: 65px;height: 38px;border-radius: 5px;">{{ value.reject_btn_caption }}</van-button>
        </div>
      </div>
    </div>
    <div :style="showIt?'opacity:1':'opacity:0'" class="applyCollapse" id="applyCollapse" :class="{ showcheck: showcheck, homeAppClassIs1: homeAppClass }" v-else>
      <van-cell v-for="(value, key) in afworkflowlist" :key="key" @click="jump(value)" style="text-align: center"
        :title="value.applistmemo">
        <div slot="icon">
          <div class="beforcell">
            <van-checkbox v-if="showcheck && !(value.ischeck || value.return)" v-model="value.checked" shape="square" />
            <div class="ico"></div>
          </div>
        </div>
        <div slot="default">
          <span :cx_flag="value.cx_flag" :class="{ st: true, ischeck: value.ischeck, isdtj: type == 5 }"
            :style="value.cx_flag == 0 ? 'color: #eb905b;background: #f5efc1;' : value.cx_flag == 1 ? 'color: #666;background: #ccc;' : value.cx_flag == 2 ? 'color: #6042d9;background: #c9c1f5;' : value.cx_flag == 3 ? 'color: #00b65b;background: #c1f5ea;' : 'color: #eb905b;background: #f5efc1;'">
            {{
              value.cx_flag == 0 ? '审批中' : value.cx_flag == 1 ? '已撤销' : value.cx_flag == 2 ? '已否决' : value.cx_flag ==
                3 ? '已通过' : value.cx_flag == 4 ? '待提交' : '请审批'
            }}
          </span>
        </div>
        <template slot="label">
          {{ value.crdate }}
        </template>
      </van-cell>
    </div>
    <div v-show="showcheck" class="footer_btn">
      <span style="font-size: 18px;color: red;font-weight: bold;">{{ tjTxt }}</span>
      <div>
        <van-button style="width: 80px;" size="small" type="info" :loading="loading" @click="_pushwxmsg"
          v-if="type == '2'">催单</van-button>
        <van-button style="width: 80px;" size="small" type="danger" :loading="loading" @click="settype(2)"
          v-if="type == '1'">否决</van-button>
        <van-button style="width: 80px;" size="small" type="info" :loading="loading" @click="settype(1)"
          v-if="type == '1'">{{ use_new_workflow ? '同意' : '提交' }}</van-button>
        <van-button style="width: 80px;" size="small" type="info" :loading="loading" @click="_postWorkFlowList"
          v-if="type == '5'">提交</van-button>
        <van-button style="width: 80px;" size="small" type="danger" :loading="loading" @click="_deleteWorkFlowList"
          v-if="type == '5'">删除</van-button>
          <van-button style="width: 80px;" size="small" type="info" :loading="loading" @click="_postWorkFlowList2"
          v-if="type == '4'">提交</van-button>
        <van-button style="width: 80px;" size="small" type="danger" :loading="loading" @click="_deleteWorkFlowList2"
          v-if="type == '4' && can_delete_whendrop">删除</van-button>
      </div>

    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
    <van-dialog v-model="showCalendar" title="单据查询" show-cancel-button :beforeClose="beforeClose2">
      <div class="documentDjcxBox">

        <van-field fieldname="kaiShiRiQi" v-model="kaiShiRiQi" readonly clickable label="开始日期"
          @click="settingDatetime(1)">
          <template #right-icon>
            <div style="display: flex;align-items: center;">
              <van-icon v-if="kaiShiRiQi" @click.stop="() => { kaiShiRiQi = '' }" style="margin-right: 5px;"
                name="close" />
              <svg-icon icon-class="calendarIcon"></svg-icon>
            </div>
          </template>
        </van-field>
        <van-field fieldname="jieShuRiQi" v-model="jieShuRiQi" readonly clickable label="结束日期"
          @click="settingDatetime(2)">
          <template #right-icon>
            <div style="display: flex;align-items: center;">
              <van-icon v-if="jieShuRiQi" @click.stop="() => { jieShuRiQi = '' }" style="margin-right: 5px;"
                name="close" />
              <svg-icon icon-class="calendarIcon"></svg-icon>
            </div>
          </template>
        </van-field>
        <van-field fieldname="gongHaoHuoXingMing" v-model="gongHaoHuoXingMing" label="工号或姓名" placeholder="请输入">

        </van-field>
      </div>
    </van-dialog>
    <van-dialog v-model="showYijian" title="请填写意见" show-cancel-button :beforeClose="beforeClose">
      <van-field v-model="yiJian" rows="5" label="请输入" type="textarea" placeholder="请输入内容" required />
    </van-dialog>
    <van-popup v-model="showDatetimePicker" position="bottom">
      <van-datetime-picker title="请选择日期" v-model="currentDatetime" type="date" @confirm="onDatetimeConfirm"
        @cancel="showDatetimePicker = false" />
    </van-popup>
    <!-- 提交意见 -->
    <van-dialog :before-close="submitMemoConfirm" v-model="showSubmitMemo" title=" " show-cancel-button
      confirm-button-text="确定">
      <van-field v-model="submitMemo" rows="3" autosize required label="请输入" type="textarea" placeholder="原因" />
    </van-dialog>
    <!-- 签名板 -->
    <van-overlay :show="signaturePadDialog" @click="signaturePadDialog = false" z-index="9">
      <div style="width:100%;height:100%;" class="wrapper" @click.stop>
        <signaturePad @getSpad="getSpad" @closeSpad="closeSpad" :show="signaturePadDialog"
          :use_last_sign_pic="use_last_user_pic" :forbit_edit_last_sign="true" :defaultUrl="signUrl" :yxcx="true"
          :isShowWindowsignremark="false"></signaturePad>
      </div>
    </van-overlay>
    <!-- 转办 -->
    <van-dialog :before-close="zhuanBanConfirm" v-model="showZhuanBanDialog" title=" " show-cancel-button>
      <van-field clickable readonly required v-model="zhuanBanUser" label="转办人" placeholder="请选择"
        @click="selectZhuanBanRen" />
      <van-field v-model="zhuanBanMessage" rows="3" autosize :required="zb_must_input_reason" label="转办原因"
        type="textarea" placeholder="请输入原因" />
    </van-dialog>
    <!-- 选择人员树弹窗 -->
    <DxPopTree ref="popTreeNode" :whichTree="whichTreeName" :module="formConfig.moduleno || formautoid"
      :multiseltree="isMultiselTree" @treeSelectValEvent="treeSelectValEvent"></DxPopTree>
    <backOut app_close_redirect_url="" ref="refBackOut" :isList="true" :listFormautoid="formautoid"
      :listMautoid="backOutAutoid" :listNodeid="backOutNodeId"></backOut>
    <!-- 审批意见 -->
    <van-dialog :before-close="checkmemoConfirm" v-model="showCheckmemo" title="" show-cancel-button
      class="tongYiShenPiDialog" :confirm-button-text="confirmBtnTextStr">
      <div class="tongYiShenPiZiDuan">
        <span style="color: #E4001B;">* </span>请输入意见
      </div>
      <textarea class="tongYiShenPiWenBenYu ccc222" v-model="checkmemo"></textarea>
      <div class="tongYiShenPiZiDuan tongYiShenPiZiDuan2" style="margin-top: 8px;"
        v-if="can_add_cs_when_check && isYesOrNo == 'yes'">
        <span style="display: flex;align-items: center;">
          <img src="@/assets/img/keepFlowGreenIcon.png" style="width: 18px;margin-right: 5px;">
          <span style="line-height: 1;font-weight: bold;">抄送人</span>
        </span>
        <van-button icon="plus" type="primary" size="mini" @click="addCsr(1)" />
      </div>
      <div style="width: 100%;height: 1px;background: #ccc;margin-top: 8px;margin-bottom: 8px;"
        v-if="can_add_cs_when_check && isYesOrNo == 'yes'"></div>
      <div class="tongYiShenBiaoQianHeZi" v-if="can_add_cs_when_check && isYesOrNo == 'yes'">
        <div class="tongYiShenBiaoQianHeZiSpan" v-for="(value, key) in csrData" :key="key">
          <span style="margin-right: 5px;">{{ value.empname }}</span>
          <van-icon @click="delCsr(value, key)" name="cross" style="position: relative;top: 1px;" />
        </div>
      </div>
      <div class="tongYiShenPiZiDuan tongYiShenPiZiDuan2" style="margin-top: 8px;"
        v-if="use_add_sign && isYesOrNo == 'yes'">
        <span style="display: flex;align-items: center;">
          <img src="@/assets/img/keepFlowYellowIcon.png" style="width: 18px;margin-right: 5px;">
          <span style="line-height: 1;font-weight: bold;">加签人</span>
        </span>
        <van-button icon="plus" type="primary" size="mini" @click="addCsr(2)" />
      </div>
      <div style="width: 100%;height: 1px;background: #ccc;margin-top: 8px;margin-bottom: 8px;"
        v-if="use_add_sign && isYesOrNo == 'yes'"></div>
      <div class="tongYiShenBiaoQianHeZi2" v-if="use_add_sign && isYesOrNo == 'yes'">
        <draggable v-model="jqrData" chosenClass="chosen" forceFallback="true" group="people"
          class="tongYiShenBiaoQianHeZi">
          <div class="tongYiShenBiaoQianHeZiSpan" v-for="(element, index) in jqrData" :key="index">
            <span style="margin-right: 5px;">{{ element.empname }}</span>
            <van-icon @click="delJqr(element, index)" name="cross" style="position: relative;top: 1px;" />
          </div>
        </draggable>
      </div>
      <div class="checklist_def_checkmemo-dialog-ope" v-if="use_add_sign && isYesOrNo == 'yes'">
        <div class="ope-left">
          <div class="ope-left-left">
            <span class="ope-left-span1">加签顺序</span>
            <div class="ope-left-div">
              <span style="margin-right: 5px;" :class="addSignStatus == 0 ? 'active' : ''" @click="addSign(0)">平行签核</span>
              <span :class="addSignStatus == 1 ? 'active' : ''" @click="addSign(1)">顺序签核</span>
            </div>
          </div>
          <div class="ope-left-right">
            <span class="ope-left-span1">加签后</span>
            <div class="ope-left-div">
              <span style="margin-right: 5px;" :class="addSignAfterStatus == 0 ? 'active' : ''"
                @click="addSignAfter(0)">回到本关卡</span>
              <span :class="addSignAfterStatus == 1 ? 'active' : ''" @click="addSignAfter(1)">进入下一关卡</span>
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
    <!-- 审批意见2（不需要意见） -->
    <van-dialog :before-close="checkmemoConfirm2" v-model="showCheckmemo2" title="" show-cancel-button
      class="tongYiShenPiDialog" confirm-button-text="同意">
      <div class="tongYiShenPiBiaoTi">是否同意？</div>
      <div class="tongYiShenPiZiDuan tongYiShenPiZiDuan2" style="margin-top: 8px;"
        v-if="can_add_cs_when_check && isYesOrNo == 'yes'">
        <span style="display: flex;align-items: center;">
          <img src="@/assets/img/keepFlowGreenIcon.png" style="width: 18px;margin-right: 5px;">
          <span style="line-height: 1;font-weight: bold;">抄送人</span>
        </span>
        <van-button icon="plus" type="primary" size="mini" @click="addCsr(1)" />
      </div>
      <div style="width: 100%;height: 1px;background: #ccc;margin-top: 8px;margin-bottom: 8px;"
        v-if="can_add_cs_when_check && isYesOrNo == 'yes'"></div>
      <div class="tongYiShenBiaoQianHeZi" v-if="can_add_cs_when_check && isYesOrNo == 'yes'">
        <div class="tongYiShenBiaoQianHeZiSpan" v-for="(value, key) in csrData" :key="key">
          <span style="margin-right: 5px;">{{ value.empname }}</span>
          <van-icon @click="delCsr(value, key)" name="cross" style="position: relative;top: 1px;" />
        </div>
      </div>
      <div class="tongYiShenPiZiDuan tongYiShenPiZiDuan2" style="margin-top: 8px;"
        v-if="use_add_sign && isYesOrNo == 'yes'">
        <span style="display: flex;align-items: center;">
          <img src="@/assets/img/keepFlowYellowIcon.png" style="width: 18px;margin-right: 5px;">
          <span style="line-height: 1;font-weight: bold;">加签人</span>
        </span>
        <van-button icon="plus" type="primary" size="mini" @click="addCsr(2)" />
      </div>
      <div style="width: 100%;height: 1px;background: #ccc;margin-top: 8px;margin-bottom: 8px;"
        v-if="use_add_sign && isYesOrNo == 'yes'"></div>
      <div class="tongYiShenBiaoQianHeZi2" v-if="use_add_sign && isYesOrNo == 'yes'">
        <draggable v-model="jqrData" chosenClass="chosen" forceFallback="true" group="people"
          class="tongYiShenBiaoQianHeZi">
          <div class="tongYiShenBiaoQianHeZiSpan" v-for="(element, index) in jqrData" :key="index">
            <span style="margin-right: 5px;">{{ element.empname }}</span>
            <van-icon @click="delJqr(element, index)" name="cross" style="position: relative;top: 1px;" />
          </div>
        </draggable>
      </div>
      <div class="checklist_def_checkmemo-dialog-ope" v-if="use_add_sign && isYesOrNo == 'yes'">
        <div class="ope-left">
          <div class="ope-left-left">
            <span class="ope-left-span1">加签顺序</span>
            <div class="ope-left-div">
              <span style="margin-right: 5px;" :class="addSignStatus == 0 ? 'active' : ''" @click="addSign(0)">平行签核</span>
              <span :class="addSignStatus == 1 ? 'active' : ''" @click="addSign(1)">顺序签核</span>
            </div>
          </div>
          <div class="ope-left-right">
            <span class="ope-left-span1">加签后</span>
            <div class="ope-left-div">
              <span style="margin-right: 5px;" :class="addSignAfterStatus == 0 ? 'active' : ''"
                @click="addSignAfter(0)">回到本关卡</span>
              <span :class="addSignAfterStatus == 1 ? 'active' : ''" @click="addSignAfter(1)">进入下一关卡</span>
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import DxPopTree from '@components/PopTree/duoXuan.vue'
import signaturePad from '@components/signaturePad'
import backOut from '@/views/workFlow/backOut.vue'
import draggable from 'vuedraggable'
import { Toast,Dialog,Notify } from 'vant';
import {
  getActionWorkFlowOfOneClass,
  getActionWorkFlow,
  getOneClassOfMyWf,
  getOneClassOfMyCheckWf,
  getReturnWorkFlowOneClass,
  pushwxmsg,
  getNotPostList,
  deleteWorkFlowList,
  postWorkFlowList,
  postWorkFlowListCheck,
  disPostWorkFlowList,
  getCsWorkFlowOfOneClass,
  updateCheckListStatus
} from '@/api/wx.js'
import {
  getWFFormBaseInfo,
  changeCheckUser,
  returnWorkFlow,
  getUserLastSignPicUrl,
  postWorkFlow,
  getBeforeActionList,
  processBeforeAction,
  upLoadUserSignPic
} from "@api/workFlow";
import { parseTime, createGguid } from '@/utils'
export default {
  data() {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    const type = this.$route.query.type
    const formautoid = this.$route.query.formautoid
    const appname = this.$route.query.appname
    const appiconid = this.$route.query.appiconid
    return {
      userInfo,
      value: '',
      type,
      formautoid,
      appname,
      appiconid,
      workflowlist: [],
      ini2: [],
      bd: '',
      ed: '',
      V3url: './',
      sstype: '所有单据',
      columns: ['所有单据', '审核完结', '审核中'],
      showPicker: false,
      showcheck: false,
      checked: false,
      showCalendar: false,
      loading: false,
      minDate: new Date(new Date().getFullYear() - 20, 0, 1),
      maxDate: new Date(new Date().getFullYear() + 20, 0, 31),
      showYijian: false,
      yiJian:"",
      selectType:0,
      errorData:[],
      homeAppClass:false,
      kaiShiRiQi:"",
      jieShuRiQi:"",
      gongHaoHuoXingMing:"",
      showDatetimePicker:false,
      currentDatetime:"",
      timeSelectType:0,
      tjTxt:"",
      submitMemo:"",
      showSubmitMemo:false,
      signaturePadDialog: false,     // 签名版插件
      signUrl:"",
      checkdatalist:[],
      checkfieldlist:[],
      showZhuanBanDialog:false,  // 选择转办人
      zhuanBanUser:"",   // 转办人
      zhuanBanUserId:"",  // 转办人ID
      zhuanBanMessage:"", // 转办原因
      isMultiselTree:false, // 单选树
      whichTreeName:"", // 忽视
      zb_must_input_reason:false,
      zbAutoid:"",
      backOutAutoid:0,
      backOutNodeId:0,
      showCheckmemo:false,   // 审批意见弹出框
      showCheckmemo2:false,
      confirmBtnTextStr:"确定",  // 审批意见确定按钮
      checkmemo:"",  // 审批意见
      isYesOrNo:"",  // 同意或否决
      csrData:[],
      jqrData:[],
      can_add_cs_when_check:false,
      use_add_sign:false,
      addCsrType:1,
      dragStartClientY:0,
      dragStartValue:null,
      dragStartIdValue:null,
      dragStartKey:0,
      dragEndValue:null,
      dragEndKey:0,
      addSignStatus:1,
      addSignAfterStatus:1,
      addType:1,
      ispostinfo:true,
      checkAutoid:0,
      checkNodeId:0,
      formConfig:{},
      mustsign:false,
      use_last_user_pic:false,    // 是否使用上次的签名
      signStatus:1,
      scroll:0,
      showIt:true
    }
  },
  components: {
    signaturePad,

    backOut,
    draggable,
    DxPopTree
  },
  beforeRouteLeave(to, from, next) {
    // 获取滚动距离
    const scroll = document.getElementById('applyCollapse').scrollTop;
    sessionStorage.setItem("wfListScrollTop",scroll)
    next()
  },
  watch:{
    '$route': {
      async handler(n,o) {
        let scroll = sessionStorage.getItem("wfListScrollTop")
        if(n.path == '/wfList'){
          this.showIt = false
          this.$nextTick(()=>{
            setTimeout(() => {
              console.log(scroll,document.getElementById('applyCollapse'),'scrollscrollscroll')
              this.showIt = true;
              document.getElementById('applyCollapse').scrollTop = Number(scroll) || 0;
            }, 300)
          })
        }
      },
      immediate: true
    }
  },
  computed: {
    title() {
      const arr = [
        '',
        localStorage.getItem('dwsp_caption')||'待我审批',
        localStorage.getItem('wfqd_caption'),
        localStorage.getItem('wysp_caption'),
        localStorage.getItem('bcxd_caption'),
        localStorage.getItem('wtjd_caption'),
        localStorage.getItem('cs_caption'),
      ]
      return arr[Number(this.type)] + (this.appname ? `(${this.appname})` : '')
    },
    use_new_workflow () {
      if(process.env.NODE_ENV !== 'production'){
        return true;
      }else{
        if(window.use_new_workflow){
          return true;
        }else{
          return false;
        }
      }
    },
    app_forchecklist_showasform () {
      const app_forchecklist_showasform = this.$route.query.app_forchecklist_showasform;
      if(app_forchecklist_showasform == 1){
        return true;
      }else{
        return false;
      }
    },
    app_forchecklist_can_batch () {
      const app_forchecklist_can_batch = this.$route.query.app_forchecklist_can_batch;
      if(app_forchecklist_can_batch == 1){
        return true;
      }else{
        return false;
      }
    },
    can_delete_whendrop () {
      const can_delete_whendrop = this.$route.query.can_delete_whendrop;
      if(can_delete_whendrop == 1){
        return true;
      }else{
        return false;
      }
    },
    queryMkeyname () {
      const mkeyname = this.$route.query.mkeyname;
      if(mkeyname){
        return mkeyname;
      }else{
        return 'autoid';
      }
    },
    afworkflowlist() {
      let arr = this.workflowlist
      switch (this.sstype) {
        case '所有单据':
          arr = this.workflowlist.filter(e => {
            return true
          })
          break
        case '审核完结':
          arr = this.workflowlist.filter(e => {
            return e.ischeck || e.return
          })
          break
        case '审核中':
          arr = this.workflowlist.filter(e => {
            return !(e.ischeck || e.return)
          })
          break
      }
      
      return arr
    }
  },
  created() {
    // total_score_title
    localStorage.setItem("RouterQueryObj",JSON.stringify(this.$route.query))
    this.type = this.$route.query.type
    this.formautoid = this.$route.query.formautoid
    this.appname = this.$route.query.appname
    this.appiconid = this.$route.query.appiconid
    this.initData()
    let getOpenApp = sessionStorage.getItem('isOpenApp')
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if(getOpenApp == 1 && isiOS){
      this.homeAppClass = true
    }
  },
  mounted() {
    setTimeout(() => {
      document.getElementsByClassName('van-tabbar-item')[0].style.color =
        '#646566'
      document.getElementsByClassName('van-tabbar-item')[1].style.color =
        '#1989fa'
    }, 200)
    this.$nextTick(async ()=>{
      await this.funGetWFFormBaseInfo()
    })
  },
  methods: {
    async funGetWFFormBaseInfo () {
      let resbi = await getWFFormBaseInfo({
        formautoid: this.formautoid,
        mautoid: 0,
        nodeid: 0,
        userid: this.userInfo.userid,
        langid: localStorage.getItem('langid') || 0,
        mtag: 0
      })
      this.formConfig = resbi.forminfo[0];
      this.can_add_cs_when_check = this.formConfig.can_add_cs_when_check
      this.use_add_sign = this.formConfig.use_add_sign
      this.use_last_user_pic = this.formConfig.use_last_user_pic
      console.log(this.formConfig,'funGetWFFormBaseInfo')
    },
    shenPiEvent (type,value) {
      console.log(type,value)
      if(type == 1){
        // 催办
        Dialog.confirm({
          title: '系统提示',
          message: '您确定催办吗？',
        }).then(() => {
          const guid = createGguid() // 生成新的guid
          const params = {
            guid: guid,
            formautoid: this.formautoid,
            username: this.userInfo.username,
            isall: false,
            mkeyfield: this.$route.query.mkeyname,
            mviewname: this.$route.query.mviewname,
            moduleqyfilter: '',
            specfilter: '',
            querysql: '',
            data: [
              {autoid:value.mautoid}
            ],
            optionfilter: []
          }
          pushwxmsg(params).then(res => {
            // console.log(res.data);
            if (res.iserror == '0'){
              Notify({ type: 'success', message: '催办成功！' });
            }
          })
        })
        .catch(() => {
          // on cancel
        });
      }else if(type == 2){
        // 转办
        this.zhuanBanUser = "";
        this.zhuanBanUserId = "";
        this.zhuanBanMessage = "";
        this.showZhuanBanDialog = true;
        this.zb_must_input_reason = value.zb_must_input_reason;
        this.zbAutoid = value.mautoid
      }else if(type == 3){
        this.backOutAutoid = value.mautoid
        this.backOutNodeId = value.nodeid
        this.$nextTick(()=>{
          this.$refs.refBackOut.getFieldList()
          this.$refs.refBackOut.showBackOutTablePicker = true;
        })
        // 回退
      }else if(type == 4){
        // 同意
        this.checkAutoid = value.mautoid
        this.checkNodeId = value.nodeid
        this.mustsign = value.mustsign
        this.isYesOrNo = "yes"
        if (!this.ispostinfo){
          this.csrData = []
          this.jqrData = [];
          this.spclEvent(this.checkAutoid,2).then(res=>{
            if(res){
              this.showCheckmemo2 = true;
            }
          }).catch(()=>{
            return;
          })
          
        }else{
          this.csrData = []
          this.jqrData = [];
          this.spclEvent(this.checkAutoid,2).then(res=>{
            if(res){
              this.checkmemo = this.formConfig.checklist_def_checkmemo;
              this.showCheckmemo = true;
              this.confirmBtnTextStr = '同意';
            }
          }).catch(()=>{
            return;
          })
        }
      }else if(type == 5){
        this.checkAutoid = value.mautoid
        this.checkNodeId = value.nodeid
        // 否决
        this.isYesOrNo = "no"
        this.csrData = [];
        this.jqrData = [];
        // spclEvent this.checkAutoid
        this.spclEvent(this.checkAutoid,3).then(res=>{
          if(res){
            this.checkmemo = this.formConfig.return_memo_default;
            this.showCheckmemo = true;
            this.confirmBtnTextStr = '否决';
          }
        }).catch(()=>{
          return;
        })
      }
    },
    addCsr (type) {
      if(type == 2){
        if(this.jqrData.length >= 10){
          Toast("加签人不能超过10人！");
          return false;
        }
      }
      this.addCsrType = type;
      this.addType = 2;
      this.isMultiselTree = true;
      this.whichTreeName="employee"
      this.$refs.popTreeNode.module = (type == 1?this.formConfig.cs_moduleno:this.formConfig.jq_moduleno)
      this.$refs.popTreeNode.treename = 'emptree'
      this.$refs.popTreeNode.fieldname = ''
      this.$refs.popTreeNode.editstate = 3
      this.$refs.popTreeNode.showEmpTreePop('员工')
    },
    delCsr (value,key) {
      this.csrData.splice(key, 1);
    },
    delJqr (value,key) {
      this.jqrData.splice(key, 1);
    },
    addSign (type) {
      this.addSignStatus = type;
    },
    addSignAfter (type) {
      this.addSignAfterStatus = type;
    },
    // 审批策略
    spclEvent (autoid,type) {
      return new Promise(async (resolve, reject) => {
        /** 
          const res1 = await getBeforeActionList({
            // 先请求保存接口1，获得acprocname
            actype: 0,
            formautoid: this.formautoid,
            username: this.userInfo.username
          })
          const arr = res1.data // acprocname数组
          let promptdata1 = []
          for (const item of arr) {
            const guid = createGguid(); // 生成新的guid
            const editstate = 2;
            const result = await processBeforeAction({
              acproname: item.acprocname,
              editstate: editstate,
              formautoid: this.formautoid,
              username: this.userInfo.username,
              autoid: autoid,
              formstr: '', // 表格填写信息
              isapp:1,
              guid:guid
            })
            if (result.data.length > 0) {
              promptdata1.push(result.data[0])
            } else {
              promptdata1.push({
                isinfo: true,
                info: result.errormsg,
                showbox: false,
                cansave: false
              })
            }
          }
          for (let i = 0; i < promptdata1.length; i++) {
            if (promptdata1[i].isinfo && !promptdata1[i].cansave) {
              if (promptdata1[i].showbox) {
                Dialog.alert({
                  message: promptdata1[i].info
                }).then(() => {})
              } else {
                Notify(promptdata1[i].info)
              }
              reject(false)
              return
            }
          }
        */
        const res2 = await getBeforeActionList({
          // 先请求保存接口1，获得acprocname
          actype: type,
          formautoid: this.formautoid,
          username: this.userInfo.username
        })
        if (res2.iserror == 0){
          const arr = res2.data;
          if (arr.length > 0){
            let promptdata = [];
            for (const item of arr){
              const editstate = 2;
              const guid = createGguid() // 生成新的guid
              const result = await processBeforeAction({
                acproname: item.acprocname,
                editstate: editstate,
                formautoid: this.formautoid,
                username: this.userInfo.username,
                autoid: autoid,
                formstr: '', 
                isapp:1,
                guid:guid
              });
              if (result.data.length > 0)
              {
                promptdata.push(result.data[0]);
              } else
              {
                promptdata.push({
                  isinfo: true,
                  info: result.errormsg,
                  showbox: false,
                  cansave: false,
                });
              }
            }
            if (promptdata.length > 0){
              let haserror = false;
              for (let i = 0; i < promptdata.length; i++){
                if (promptdata[i].isinfo){
                  if (promptdata[i].showbox){
                    if (promptdata[i].cansave){
                      const a = await this.ask(promptdata[i].info);
                      if (!a){
                        haserror = true;
                        return;
                      }
                    } else{
                      haserror = true;
                      Dialog.alert({
                        message: promptdata[i].info,
                      }).then(() => {});
                      return;
                    }
                  } else{
                    haserror = true;
                    Notify(promptdata[i].info)
                  }
                }
              }
              if (!haserror){
                resolve(true);
              }else{
                reject(false)
              }
            }else{
              resolve(true);
            }
          }else{
            resolve(true);
          }
        }
      })
    },
    ask (msg) {
      return new Promise((resolve, reject) => {
        Dialog.confirm({
          title: '系统提示',
          message: msg,
        })
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
      });
    },
    checkmemoConfirm (action, done) {
      if(action == 'confirm'){
        if(this.isYesOrNo == 'no'){
          if(!this.checkmemo){
            Toast("原因不能为空！")
            done(false);
            return;
          }
          returnWorkFlow({
            formautoid: this.formautoid,
            checkmemo: this.checkmemo,
            autoid: this.checkAutoid,
            editstate: 3,
            username: this.userInfo.username,
            formstr: '',
            flag:4,
            nodeid:this.checkNodeId,
          }).then((res) => {
            this.showCheckmemo = false;
            done();
            this.initData()
            Toast("操作成功！")
          }).catch(()=>{
            done(false);
          })
          
          
        }else{
          if(this.csrData && this.csrData.length > 0){
            if(this.csrData.length > 30){
              Notify("抄送人不能大于30！")
              return false;
            }
          }
          if(this.jqrData && this.jqrData.length > 0){
            if(this.jqrData.length > 10){
              Notify("加签人不能大于10！")
              return false;
            }
          }
          if (this.mustsign)
          {
            this.showCheckmemo = false;
            this.getUserLastSignPicUrlFun();
            done();
          }else{
            this.checkSubmit().then(res=>{
              this.showCheckmemo = false;
              done();
              
            }).catch((err)=>{
              done(false);
            })
          }
        }        
      }else{
        this.showCheckmemo = false;
        done();
      }
    },
    checkmemoConfirm2 (action, done) {
      if(action == 'confirm'){
        if(this.csrData && this.csrData.length > 0){
          if(this.csrData.length > 60){
            Notify("抄送人不能大于60！")
            return false;
          }
        }
        if(this.jqrData && this.jqrData.length > 0){
          if(this.jqrData.length > 10){
            Notify("加签人不能大于10！")
            return false;
          }
        }
        this.checkmemo = "";
        if (this.mustsign){
          this.getUserLastSignPicUrlFun();
        } else{
          this.checkSubmit();
        }
        this.showCheckmemo2 = false
        done();
      }else{
        this.showCheckmemo2 = false
        done();
      }
    },
    checkSubmit () {
      return new Promise((resolve, reject) => {
        const editstate = 2
        let str = '';
        let str2 = '';
        if(this.csrData && this.csrData.length > 0){   
            str = this.csrData.map((item)=>{
                return item.empid
            }).join(",")
        }
        if(this.jqrData && this.jqrData.length > 0){   
            str2 = this.jqrData.map((item)=>{
                return item.empid
            }).join(",")
        }
        postWorkFlow({
          formautoid: this.formautoid,
          checkmemo: this.checkmemo,
          autoid: this.checkAutoid,
          editstate: editstate,
          username: this.userInfo.username,
          formstr: '',
          flag:4,
          nodeid:this.checkNodeId,
          isapp:1,
          cs_empid_list:str,
          add_sign_empid_list:str2,
          add_sign_order:this.addSignStatus,
          add_sign_after:this.addSignAfterStatus,
          saveormodify:'check'
        }).then((res) => {
          this.signaturePadDialog = false;
          resolve(res)
          this.initData();
          Toast("操作成功！")
        }).catch((err)=>{
          reject(err)
        })
      })
    },
    // 根据是否需要获取上一次的签名，打开签名框
    getUserLastSignPicUrlFun () {
      this.signStatus = 2
      if(this.use_last_user_pic){
        getUserLastSignPicUrl({
          formautoid: this.formautoid,
          mautoid:this.checkAutoid,
          nodeid:this.checkNodeId,
          userid: this.userInfo.userid,
          username:this.userInfo.username,
        }).then(res=>{
          if(res.data && res.data.length > 0){
            this.signUrl = res.data[0].picurl
          }
          this.signaturePadDialog = true;
        })
      }else{
        this.signaturePadDialog = true;
      }
    },
    // 转办确定
    zhuanBanConfirm (action, done) {
      if(action == 'confirm'){
        if(!this.zhuanBanUser){
          Toast("转办人必填！")
          done(false);
          return;
        }
        if(!this.zhuanBanMessage && this.zb_must_input_reason){
          Toast("转办原因必填！")
          done(false);
          return;
        }else{
          changeCheckUser({
            dtid: this.zbAutoid,
            empid: this.zhuanBanUserId,
            username: this.userInfo.username,
            zb_reason: this.zhuanBanMessage
          }).then(res => {
            if (res.data[0].info){
              Notify(res.data[0].info);
            } else {
              Notify({ type: 'success', message: '转办成功！' });
            }
            this.showZhuanBanDialog = false;
            done();
          })
        }
      }else{
        this.showZhuanBanDialog = false;
        done();
      }
    },
    // 选择转办人
    selectZhuanBanRen () {
      this.addType = 1;
      this.whichTreeName="employee"
      this.$refs.popTreeNode.module = this.formConfig.moduleno || this.formautoid
      this.$refs.popTreeNode.treename = 'emptree'
      this.$refs.popTreeNode.fieldname = ''
      this.$refs.popTreeNode.editstate = 3
      this.$refs.popTreeNode.isZB = true;
      this.$refs.popTreeNode.formautoid = this.formautoid;
      this.$refs.popTreeNode.showEmpTreePop('员工')
    },
    treeSelectValEvent (data) {
      if(this.addType == 3){
        this.csrData3 = [...this.csrData3,...data];
      }else{
        if(this.addType == 2){
          if(this.addCsrType == 1){
            this.csrData = [...this.csrData,...data];
          }else{
            let arr = [...this.jqrData,...data];
            this.jqrData = arr.slice(0,10);
          }
        }else{
          this.zhuanBanUser = data.empname;
          this.zhuanBanUserId = data.empid;
        }
      }
    },
    // 签名版回调
    async getSpad (url) {
      if(this.signStatus == 1){
        const arr = this.workflowlist.filter(e => {
          return e.checked
        })
        let autoidlist = arr.map(e=>{
          return e.mautoid;
        })
        await this.fromProcessEvent(
          this.$route.query.formautoid,
          this.yiJian,
          autoidlist,
          1,
          url
        )
        this.initData()
        this.signaturePadDialog = false
      }else{
        upLoadUserSignPic({
          filebase64str: url,
          formautoid: this.formautoid,
          mautoid: this.checkAutoid,
          nodeid: this.checkNodeId,
          uploadpath: this.userInfo.formfilepath,
          username: this.userInfo.username,
        }).then(res => {
            // 签名成功，则提交
            this.checkSubmit();
        })
      }
      
    },
    // 关闭签名板
    closeSpad () {
      this.signaturePadDialog = false
    },
    toJiLa () {
      let n = this.afworkflowlist;
      let total_score_title = this.$route.query.total_score_title;
      let show_total_score = this.$route.query.show_total_score;
      if(show_total_score == 1 && total_score_title){
        let num = 0;
        n.forEach(item=>{
          if(item.totalscore && !isNaN(item.totalscore)){
            if(item.checked){
              num = num + item.totalscore;
            }
          }
        })
        num = num.toFixed(2);
        if(isNaN(num)){
          this.tjTxt = total_score_title.replace("{totalscore}","0.00");
        }else{
          const txt = total_score_title.replace("{totalscore}",num)
          this.tjTxt = txt;
        }
      }
    },
    settingDatetime (type) {
      this.timeSelectType = type;
      if(type == 1){
        this.currentDatetime = this.kaiShiRiQi?new Date(this.kaiShiRiQi):new Date()
      }else{
        this.currentDatetime = this.jieShuRiQi?new Date(this.jieShuRiQi):new Date()
      }
      this.showDatetimePicker = true;
    },
    onDatetimeConfirm (time) {
      const vv = parseTime(time, '{y}-{m}-{d}');
      if(this.timeSelectType == 1){
        this.kaiShiRiQi = vv;
      }else{
        this.jieShuRiQi = vv;
      }
      this.showDatetimePicker = false;
    },
    onShowCalendar () {
      this.kaiShiRiQi = parseTime(new Date(), '{y}-{m}-{d}');
      this.jieShuRiQi = parseTime(new Date(), '{y}-{m}-{d}');
      this.gongHaoHuoXingMing = "";
      this.showCalendar = true;
    },
    beforeClose2(action, done) {
      if (action === "confirm") {
        this.bd = this.kaiShiRiQi
        this.ed = this.jieShuRiQi
        this.initData()
        this.showCalendar = false
        done();
      }else{
        this.showCalendar = false
        done();
      }
    },
    async initData() {
      switch (this.type) {
        case '1':
          if (this.formautoid == '0') {
            // 待我审批
            await getActionWorkFlow({
              empcode: this.userInfo.empcode,
              langid: localStorage.getItem('langid'),
              bd: this.bd,
              ed: this.ed,
              query_empcode:this.gongHaoHuoXingMing
            }).then(res => {
              this.bulid(res.data)
            })
          } else {
            // 待我审批(一类)
            await getActionWorkFlowOfOneClass({
              empcode: this.userInfo.empcode,
              formautoid: this.formautoid,
              langid: localStorage.getItem('langid'),
              bd: this.bd,
              ed: this.ed,
              query_empcode:this.gongHaoHuoXingMing
            }).then(res => {
              if(this.app_forchecklist_showasform){
                this.checkdatalist = res.checkdatalist;
                this.checkfieldlist = res.checkfieldlist;
              }
              this.bulid(res.data);
              
            })
          }

          break
        case '2':
          // 我发起的
          await getOneClassOfMyWf({
            empcode: this.userInfo.empcode,
            formautoid: this.formautoid,
            langid: localStorage.getItem('langid'),
            bd: this.bd,
            ed: this.ed,
            query_empcode:this.gongHaoHuoXingMing
          }).then(res => {
            this.bulid(res.data)
          })
          break
        case '3':
          // 已通过
          await getOneClassOfMyCheckWf({
            empcode: this.userInfo.empcode,
            formautoid: this.formautoid,
            langid: localStorage.getItem('langid'),
            bd: this.bd,
            ed: this.ed,
            query_empcode:this.gongHaoHuoXingMing
          }).then(res => {
            this.bulid(res.data)
          })
          break
        case '4':
          // 被撤销的
          await getReturnWorkFlowOneClass({
            empcode: this.userInfo.empcode,
            formautoid: this.formautoid,
            langid: localStorage.getItem('langid'),
            bd: this.bd,
            ed: this.ed,
            query_empcode:this.gongHaoHuoXingMing
          }).then(res => {
            this.bulid(res.data)
          })
          break
        case '5':
          // 未提交的
          await getNotPostList({
            empcode: this.userInfo.empcode,
            formautoid: this.formautoid,
            langid: localStorage.getItem('langid'),
            bd: this.bd,
            ed: this.ed,
            query_empcode:this.gongHaoHuoXingMing
          }).then(res => {
            this.bulid(res.data)
          })
          break
        case '6':
          await getCsWorkFlowOfOneClass({
            empcode: this.userInfo.empcode,
            formautoid: this.formautoid,
            langid: localStorage.getItem('langid'),
            bd: this.bd,
            ed: this.ed,
            query_empcode:this.gongHaoHuoXingMing
          }).then(res => {
            this.bulid(res.data)
          })
          break  
        default:
          break
      }
    },
    // 构造分组列表
    bulid(data) {
      this.workflowlist = []
      data.forEach((e, i) => {
        e.appiconid = this.appiconid
        if (this.formautoid != '0') {
          e.appname = this.appname
          e.formautoid = this.formautoid
          e.check = false
        }
      })
      this.ini2 = JSON.parse(JSON.stringify(data))
      this.workflowlist = data
      if(this.app_forchecklist_showasform && this.type == 1 && this.formautoid != 0 && this.workflowlist && this.workflowlist.length > 0){

        this.checkdatalist.forEach(value=>{
          
          let arr = [];
          this.checkfieldlist.forEach(item=>{
            let obj = {
              key:item.chnname,
              value:value[item.fieldname],
              fieldname:item.fieldname
            }
            arr.push(obj)
          })
          value.newArr = arr;
        })
        this.workflowlist.forEach(item=>{
          this.checkdatalist.forEach(value=>{
            if(item.mautoid == value[this.queryMkeyname]){
              item.checkdatalist = value
            }
          })
        })
        console.log(this.workflowlist,'lfwhfkwhe')
      }
    },
    onClickLeft() {
      if (this.type == '1' && this.formautoid == '0') {
        this.$router.push({
          path: '/apply'
        })
      } else {
        this.$router.push({
          path: '/wfClass',
          query: { type: this.type }
        })
      }
    },
    onClickRight() {},
    onSearch(val) {
      if (val) {
        this.workflowlist = this.ini2.filter(e => {
          return e.applistmemo.indexOf(val) > -1
        })
      } else {
        this.workflowlist = JSON.parse(JSON.stringify(this.ini2))
      }
    },
    onCancel() {
      this.value = ''
      this.workflowlist = JSON.parse(JSON.stringify(this.ini2))
    },
    jump(v) {
      
      if(this.showcheck){
        v.checked = !v.checked;
        this.toJiLa();
        this.$forceUpdate();
        return
      }
      if(window.use_new_wf_form == 1 || process.env.NODE_ENV !== 'production'){
        if(this.type == '6'){
          const queryObj = {
            saveormodify:"readonly",
            mautoid:v.mautoid,
            formautoid:v.formautoid,
            formname:v.appname,
            nodeid:v.nodeid,
            documentType:this.type,
            time: new Date().getTime()
          }
          this.$router.push({
            path: '/workFlow',
            query: queryObj
          })
          
        }else{
          var url = ''
          if (this.type == '5') {
            const queryObj = {
              saveormodify:"modify",
              mautoid:v.mautoid,
              formautoid:v.formautoid,
              formname:v.appname,
              nodeid:1,
              documentType:this.type,
              time: new Date().getTime(),
              
            }
            this.$router.push({
              path: '/workFlow',
              query: queryObj
            })
          } else if(this.type == '4'){
            const queryObj = {
              saveormodify:"modify",
              mautoid:v.mautoid,
              formautoid:v.formautoid,
              formname:v.appname,
              nodeid:v.nodeid,
              documentType:this.type,
              time: new Date().getTime(),
            }
            this.$router.push({
              path: '/workFlow',
              query: queryObj
            })
          } else if(this.type == '2'){
            const queryObj = {
              saveormodify:"readonly",
              mautoid:v.mautoid,
              formautoid:v.formautoid,
              formname:v.appname,
              nodeid:1,
              documentType:this.type,
              time: new Date().getTime(),
              m_ischeck:v.m_ischeck,
              queryCxFlag:v.cx_flag
            }
            this.$router.push({
              path: '/workFlow',
              query: queryObj
            })
          } else if(this.type == '3'){
            const queryObj = {
              saveormodify:"readonly",
              mautoid:v.mautoid,
              formautoid:v.formautoid,
              formname:v.appname,
              nodeid:v.nodeid,
              documentType:this.type,
              time: new Date().getTime(),
              m_ischeck:v.m_ischeck,
            }
            this.$router.push({
              path: '/workFlow',
              query: queryObj
            })
          }else {
            const queryObj = {
              saveormodify:"check",
              mautoid:v.mautoid,
              formautoid:v.formautoid,
              formname:v.appname,
              nodeid:v.nodeid,
              documentType:this.type,
              time: new Date().getTime(),
            }
            this.$router.push({
              path: '/workFlow',
              query: queryObj
            })
          }
        }
      }else{
        if(this.type == '6'){
          updateCheckListStatus({
            checkuserid: this.userInfo.userid,
            formautoid: v.formautoid,
            autoid: v.mautoid,
            flag: 3
          }).then(res=>{
            setLocVal('wfqdinfo', v.autoid)
            setLocVal('wfqdlist', v.formautoid)
            var url = ''
            if (this.type == '5') {
              setLocVal(
                'hyrptparas',
                this.appname + '|' + '' + url + '|' + '' + v.autoid
              )
              url = 'shengpiinfoOnly.html'
            } else {
              setLocVal('sptype', this.type)
              setLocVal(
                'wfqdinfomsg',
                v.appiconid + '|' + v.applistmemo + '|' + v.crdate
              )
              setLocVal('candroplist', v.candroplist)
              url = 'wfqdinfo.html'
            }
            let href = this.V3url + '/weixinlocal/queryrpt/' + url
            this.$router.push({
              path: '/jump',
              query: { url: href, time: new Date().getTime() }
            })
          })
        }else{
          setLocVal('wfqdinfo', v.autoid)
          setLocVal('wfqdlist', v.formautoid)
          var url = ''
          if (this.type == '5') {
            setLocVal(
              'hyrptparas',
              this.appname + '|' + '' + url + '|' + '' + v.autoid
            )
            url = 'shengpiinfoOnly.html'
          } else {
            setLocVal('sptype', this.type)
            setLocVal(
              'wfqdinfomsg',
              v.appiconid + '|' + v.applistmemo + '|' + v.crdate
            )
            setLocVal('candroplist', v.candroplist)
            url = 'wfqdinfo.html'
          }
          let href = this.V3url + '/weixinlocal/queryrpt/' + url
          this.$router.push({
            path: '/jump',
            query: { url: href, time: new Date().getTime() }
          })
        }
      }
    },
    async fromProcessEvent (formautoid, checkmemo, autoid, editstate,url) {
      
      if (editstate == 1) {
        let resbi = await getWFFormBaseInfo({
          formautoid: formautoid,
          mautoid: 0,
          nodeid: 0,
          userid: this.userInfo.userid,
          langid: localStorage.getItem('langid') || 0,
          mtag: 0
        })
        const moduleConfig = resbi.forminfo[0]
        const params = {
          guid: createGguid(),
          formautoid: formautoid,
          mkeyname: moduleConfig.mkeyname,
          mtablename: moduleConfig.mtablename,
          mviewname: moduleConfig.mviewname,
          isall: 0,
          autoidlist: autoid?autoid.join(","):'',
          moduleqyfilter: '',
          specfilter: '1=1',
          querysql: '1=1',
          username: this.userInfo.username,
          checkmemo: checkmemo,
          queryindex: 0,
          optionfilter: [],
          flag: 1,
          filebase64str:url
        }
        const res = await postWorkFlowListCheck(params)
        if (res.iserror == 0)
        {
          if (res.data.length > 0)
          {
            this.errorData.push({ res: res.data[0].res })
          }
        }
      } else
      {
        let resbi = await getWFFormBaseInfo({
          formautoid: formautoid,
          mautoid: 0,
          nodeid: 0,
          userid: this.userInfo.userid,
          langid: localStorage.getItem('langid') || 0,
          mtag: 0
        })
        const moduleConfig = resbi.forminfo[0]
        const params = {
          guid: createGguid(),
          formautoid: formautoid,
          mkeyname: moduleConfig.mkeyname,
          mtablename: moduleConfig.mtablename,
          mviewname: moduleConfig.mviewname,
          isall: 0,
          autoidlist: autoid?autoid.join(","):'',
          moduleqyfilter: '',
          specfilter: '1=1',
          querysql: '1=1',
          username: this.userInfo.username,
          checkmemo: checkmemo,
          queryindex: 0,
          optionfilter: [],
          flag: 1
        }
        const res = await disPostWorkFlowList(params)
        if (res.iserror == 0)
        {
          if (res.data.length > 0)
          {
            this.errorData.push({ res: res.data[0].res })
          }
        }
      }
    },

    async beforeClose (action, done) {
      if (action === "confirm") {
        if(!this.yiJian){
          Toast('意见必填！')
          done(false);
          return;
        }else{
          const arr = this.workflowlist.filter(e => {
            return e.checked
          })
          let autoidlist = arr.map(e=>{
            return e.mautoid;
          })
          console.log(autoidlist,'arrarrarr')
          if(this.selectType == 1){
            if(this.$route.query.app_batch_check_need_sign == 1){
              this.signStatus = 1
              this.signaturePadDialog = true;
              this.showcheck = false;
              if (this.errorData.length > 0){
                Dialog.alert({
                  message: JSON.stringify(this.errorData)
                }).then(() => {})
              }
            }else{
              await this.fromProcessEvent(
                this.$route.query.formautoid,
                this.yiJian,
                autoidlist,
                1
              )
              this.initData()
              this.showcheck = false;
              if (this.errorData.length > 0){
                Dialog.alert({
                  message: JSON.stringify(this.errorData)
                }).then(() => {})
              }
            }
            
          }else{
            await this.fromProcessEvent(
              this.$route.query.formautoid,
              this.yiJian,
              autoidlist,
              2
            )
            this.initData()
            this.showcheck = false;
            if (this.errorData.length > 0){
              Dialog.alert({
                message: JSON.stringify(this.errorData)
              }).then(() => {})
            }
          }
          done();
          
        }

      } else {
        done();
      }
    },
    
    settype(v) {
      if(this.use_new_workflow){
        this.selectType = v;
        const arr = this.workflowlist.filter(e => {
          return e.checked
        })
        if(arr.length > 0){
          if(v == 1){
            this.yiJian = this.$route.query.checklist_def_checkmemo || '同意'
            this.showYijian = true;
          }else{
            this.yiJian = ''
            this.showYijian = true;
          }
        }else{
          Toast('请选择记录！')
        }
      }else{
        setLocVal('settype', v)
        setLocVal('can_appbg_batch_check', '0')
        if (v.can_appbg_batch_check) {
          setLocVal('can_appbg_batch_check', '1') // 是否后台批量处理
        }
        let list = this.afworkflowlist.filter(e => {
          return e.checked && !(e.ischeck || e.return)
        })
        if (list.length == 0) {
          Toast('请选择记录！')
          return
        }
        this.loading = true
        setLocVal(
          'hywfautoidlist',
          list
            .map(e => {
              return e.autoid
            })
            .join('|')
        )
        setLocVal(
          'hywfformautoidlist',
          list
            .map(e => {
              return e.formautoid
            })
            .join('|')
        )
        setLocVal(
          'hywfapplistmemolist',
          list
            .map(e => {
              return e.applistmemo
            })
            .join('|')
        )
        var url = 'settypebatch.html'
        let href = this.V3url + '/weixinlocal/queryrpt/' + url
        this.$router.push({
          path: '/jump',
          query: { url: href, time: new Date().getTime() }
        })
      }
    },
    onConfirm(value) {
      this.sstype = value
      this.showPicker = false
    },
    
    checkAll(checked) {
      this.workflowlist.forEach(e => {
        e.checked = checked
      })
      this.toJiLa();
      this.$forceUpdate()
    },
    _pushwxmsg() {
      const guid = createGguid()
      let data = this.afworkflowlist
        .filter(e => {
          return e.checked && !(e.ischeck || e.return)
        })
        .map(e => {
          return { autoid: e.mautoid }
        })
      if (data.length == 0) {
        Toast('请选择记录！')
        return
      }
      this.loading = true
      pushwxmsg({
        guid,
        data,
        formautoid: this.formautoid,
        username: this.userInfo.username,
        formautoid: this.formautoid,
        mkeyfield: this.$route.query.mkeyname,
        mtablename: this.$route.query.mtablename,
        mviewname: this.$route.query.mviewname
      })
        .then(res => {
          Toast('催单成功')
        })
        .finally(() => {
          this.loading = false
        })
    },
    _postWorkFlowList() {
      let autoidlist = this.afworkflowlist
        .filter(e => {
          return e.checked
        })
        .map(e => {
          return e[this.$route.query.mkeyname]
        })
      if (autoidlist.length == 0) {
        Toast('请选择记录！')
        return
      }
      if(
        this.$route.query.first_post_need_checkmemo == 1 && 
        (this.$route.query.type == 5 || this.$route.query.type == 4)
      ){
        this.submitMemo = this.$route.query.first_post_def_checkmemo || '同意'
        this.showSubmitMemo = true;
      }else{
        Dialog.confirm({
          // title: '标题',
          message: '确认提交吗？'
        }).then(() => {
          this.loading = true
          const guid = createGguid()

          postWorkFlowList({
            guid,
            autoidlist: autoidlist.join(','),
            formautoid: this.formautoid,
            username: this.userInfo.username,
            formautoid: this.formautoid,
            mkeyname: this.$route.query.mkeyname,
            mtablename: this.$route.query.mtablename,
            mviewname: this.$route.query.mviewname,
            checkmemo:""
          }).then(res => {
            Toast('提交成功')
            this.initData()
          })
          .finally(() => {
            this.loading = false
          })
        })
      }
    },
    async _postWorkFlowList2() {
      let resbi = await getWFFormBaseInfo({
        formautoid: this.formautoid,
        mautoid: 0,
        nodeid: 0,
        userid: this.userInfo.userid,
        langid: localStorage.getItem('langid') || 0,
        mtag: 0
      })
      const moduleConfig = resbi.forminfo[0]
      let autoidlist = this.afworkflowlist.filter(e => {
        return e.checked
      }).map(e => {
        return e['mautoid']
      })
      if (autoidlist.length == 0) {
        Toast('请选择记录！')
        return
      }
      Dialog.confirm({
        // title: '标题',
        message: '确认提交吗？'
      }).then(() => {
        this.loading = true
        const guid = createGguid()

        postWorkFlowList({
          guid,
          autoidlist: autoidlist.join(','),
          formautoid: this.formautoid,
          username: this.userInfo.username,
          mkeyname: moduleConfig.mkeyname,
          mtablename: moduleConfig.mtablename,
          mviewname: moduleConfig.mviewname,
          checkmemo:"",
          queryindex:3
        }).then(res => {
          Toast('提交成功')
          this.initData()
        })
        .finally(() => {
          this.loading = false
        })
      })
    },
    // 提交
    submitMemoConfirm (action, done) {
      if(action == 'confirm'){
        let autoidlist = this.afworkflowlist.filter(e => {
          return e.checked
        }).map(e => {
          return e[this.$route.query.mkeyname]
        })
        this.loading = true
        const guid = createGguid()
        postWorkFlowList({
          guid,
          autoidlist: autoidlist.join(','),
          formautoid: this.formautoid,
          username: this.userInfo.username,
          formautoid: this.formautoid,
          mkeyname: this.$route.query.mkeyname,
          mtablename: this.$route.query.mtablename,
          mviewname: this.$route.query.mviewname,
          checkmemo:this.submitMemo
        }).then(res => {
          Toast('提交成功')
          this.initData()
          this.showSubmitMemo = false;
          done();
        })
        .finally(() => {
          this.loading = false
        })
      }else{
        this.showSubmitMemo = false;
        done();
      }
    },
    async _deleteWorkFlowList2 () {
      let resbi = await getWFFormBaseInfo({
        formautoid: this.formautoid,
        mautoid: 0,
        nodeid: 0,
        userid: this.userInfo.userid,
        langid: localStorage.getItem('langid') || 0,
        mtag: 0
      })
      const moduleConfig = resbi.forminfo[0]
      let autoidlist = this.afworkflowlist.filter(e => {
        return e.checked
      }).map(e => {
        return e['mautoid']
      })
      if (autoidlist.length == 0) {
        Toast('请选择记录！')
        return
      }
      Dialog.confirm({
        // title: '标题',
        message: '确认删除吗？'
      }).then(() => {
        this.loading = true
        const guid = createGguid()

        deleteWorkFlowList({
          guid,
          autoidlist: autoidlist.join(','),
          formautoid: this.formautoid,
          username: this.userInfo.username,
          mkeyname: moduleConfig.mkeyname,
          mtablename: moduleConfig.mtablename,
          mviewname: moduleConfig.mviewname
        })
          .then(res => {
            Toast('删除成功')
            this.initData()
          })
          .finally(() => {
            this.loading = false
          })
      })
      console.log(autoidlist,'autoidlist')
    },
    _deleteWorkFlowList() {
      let autoidlist = this.afworkflowlist
        .filter(e => {
          return e.checked
        })
        .map(e => {
          return e[this.$route.query.mkeyname]
        })
      if (autoidlist.length == 0) {
        Toast('请选择记录！')
        return
      }

      Dialog.confirm({
        // title: '标题',
        message: '确认删除吗？'
      }).then(() => {
        this.loading = true
        const guid = createGguid()

        deleteWorkFlowList({
          guid,
          autoidlist: autoidlist.join(','),
          formautoid: this.formautoid,
          username: this.userInfo.username,
          formautoid: this.formautoid,
          mkeyname: this.$route.query.mkeyname,
          mtablename: this.$route.query.mtablename,
          mviewname: this.$route.query.mviewname
        })
          .then(res => {
            Toast('删除成功')
            this.initData()
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wfClass {
  height: 100vh;
  overflow: hidden;

  .van-nav-bar {
    background: #2b8df0;
    height: 92px;

    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }

    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }

    ::v-deep .van-nav-bar__right {
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }

  .van-icon {
    padding: 0 0.21333rem;
    color: #323233;
    font-size: 0.37333rem;
    line-height: 0.90667rem;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
  }

  .search {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f6f6f6;
    .van-search {
      flex: 1;
    }

    .gettype {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      font-size: 26px;

      span {
        background: #ddd;
        padding: 10px 0 10px 20px;
        border-radius: 20px;
      }
    }
  }

  .applyCollapse {
    width: 100%;
    background: #f2f2f2;
    // transition: 0.3;
    &.showcheck {
      height: calc(100vh - 6.3rem);
    }

    padding: 10px;
    overflow-y: scroll;
    height: calc(100vh - 4.5rem);

    &.homeAppClassIs1 {

      // height: calc(100vh - 5.56667rem);
      &.showcheck {
        // height: calc(100vh - 7.36667rem);
      }
    }

    .van-collapse {
      background: #fff;
      border-radius: 20px;
      padding: 10px;
    }

    /deep/.van-cell {
      background: #fff;
      border-radius: 20px;
      padding: 10px;
      margin-bottom: 10px;

      .beforcell {
        display: flex;

        .ico {
          width: 8px;
          height: 22px;
          background: #bd50d3;
          border-radius: 2px;
          margin: 10px;
        }
      }

      .van-cell__title {
        flex: 2;
        text-align: left;
      }

      .st {
        text-align: center;
        color: rgb(235, 144, 91);
        background: rgb(245, 239, 193);
        border-radius: 30px;
        padding: 10px 20px;
      }

      .st.ischeck {
        color: #00b65b;
        background: #c1f5ea;
      }

      .st.isdtj {}
    }
  }

  .footer_btn {
    width: 100%;
    padding: 0.26667rem 0;
    position: fixed;
    bottom: 1.8rem;
    left: 0;
    z-index: 100;
    display: flex;
    background-color: #fff;
    align-items: flex-end;
    justify-content: space-between;
    padding-left: 0.2rem;

    ::v-deep .van-checkbox__icon {
      margin-left: 0.13333rem;
    }

    ::v-deep .van-checkbox__label {
      font-size: 0.48rem;
      font-family: Source Han Sans CN;
      font-weight: 500;
    }

    .van-button {

      margin-right: 0.2rem;
      border-radius: 9px;
      width: 3rem;

      .van-button__text {
        font-size: 0.4rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
      }
    }
  }
}

.documentDjcxBox {}

.appForchecklistShowasformContainer {
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  color: #323233;
  font-size: 0.37333rem;
  line-height: 0.64rem;
  background-color: #fff;
  background: #fff;
  border-radius: 0.26667rem;
  padding: 0.3rem 0.13333rem;
  margin-bottom: 0.13333rem;
  position: relative;
}

.appForchecklistShowasformContainerTop {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .appForchecklistShowasformContainerTopLeft {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 600;
    font-size: 36px;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
    flex: 2;
    line-height: 1;
    display: flex;
    align-items: center;

    .beforcell {
      margin-right: 12px;
    }
  }

  .appForchecklistShowasformContainerTopRight {
    position: relative;
    overflow: hidden;
    color: #969799;
    text-align: right;
    vertical-align: middle;
    word-wrap: break-word;

    span {
      text-align: center;
      border-radius: 0.4rem;
      padding: 0.13333rem 0.26667rem;
      flex: 1;
    }
  }
}

.appForchecklistShowasformContainerBodyContent {
  display: flex;
  align-items: flex-end;

  .appForchecklistShowasformContainerBodyLeft {
    flex: 1;
    text-align: left;
    color: #666;
  }

  .appForchecklistShowasformContainerBodyRight {
    flex: 3;
    font-weight: 600;
    color: #333333;
  }
}

.appForchecklistShowasformContainerFooter {
  margin-top: 0.3rem;
  border-top: 1px solid rgba(153, 153, 153, 0.2);
  display: flex;
  padding-top: 0.3rem;

  // justify-content: space-between;
  /deep/.van-button {
    margin-right: 12px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.appForchecklistShowasformContainerBody {
  margin-top: 0.2rem;
}

.tongYiShenPiDialog {
  /deep/.van-dialog__content {
    padding: 10px 27px 20px 27px;
  }

  .tongYiShenPiBiaoTi {
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    padding: 20px 0;
  }

  .tongYiShenPiZiDuan {
    font-size: 28px;
  }

  .tongYiShenPiZiDuan2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 25px !important;

    /deep/.van-button {
      color: #fff !important;
      border: 1px solid #1890FF !important;
      background: #1890FF !important;
    }
  }

  .tongYiShenPiWenBenYu {
    width: 100%;
    margin-top: 12px;
    height: 150px;
    border-radius: 10px;
    border: 1px solid #ccc;
    font-size: 28px;
    padding: 12px;
  }

  .tongYiShenBiaoQianHeZi {
    width: 100%;
    display: flex;
    max-height: 700px;
    overflow: auto;
    padding-bottom: 10px;
    flex-wrap: wrap;

    .tongYiShenBiaoQianHeZiSpan {
      background: #F4F4F4;
      border-radius: 5px;
      padding: 0 24px;
      font-size: 24px;
      height: 48px;
      display: flex;
      align-items: center;
      margin-right: 20px;
      margin-top: 10px;
    }
  }

  .tongYiShenBiaoQianHeZi2 {
    .tongYiShenBiaoQianHeZi {
      overflow: hidden !important;
    }
  }

  .checklist_def_checkmemo-dialog-ope {
    margin-top: 15px;

    .ope-left-left,
    .ope-left-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .ope-left-span1 {
      font-size: 28px;
      color: #666;
    }

    .ope-left-div {
      width: 399px;
      height: 50px;
      background: rgb(241, 241, 241);
      border-radius: 5px 5px 5px 5px;
      display: flex;
      align-items: center;

      span {
        text-align: center;
        font-size: 28px;
        cursor: pointer;
        display: block;
        width: 50%;
        height: 50px;
        line-height: 50px;

        &.active {
          background: #E6A23C;
          color: #fff;
          border-radius: 5px 5px 5px 5px;
          padding: 0px 10px;
        }
      }
    }
  }

  .tongYiShenTianJia {
    /deep/.van-button {
      color: #1890FF !important;
      border: 1px solid #1890FF !important;
    }
  }
}
</style>
